import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
export default function FindUsInBialystok() {
  return <section data-section-id="112605" id="gdzie-działamy" className="bg-background text-foreground w-full flex flex-col lg:flex-row min-h-[700px] overflow-hidden border-y border-border">
      {}
      <div className="w-full lg:w-[40%] p-6 sm:p-12 lg:p-16 flex flex-col justify-center relative z-10 bg-background border-r border-border">
        <div className="max-w-md mx-auto w-full">
          <div className="mb-10">
            <h2 className="text-4xl md:text-5xl font-sans font-extrabold text-foreground mb-4 tracking-tighter">
              Gdzie <span className="text-primary">działamy?</span>
            </h2>
            <p className="text-muted-foreground font-medium leading-relaxed">Zapewniamy profesjonalne czyszczenie instalacji CO na terenie Pszczyny oraz całego województwa Śląskiego oraz Małpopolskiego. Dojeżdżamy bezpośrednio do Twojego domu.</p>
          </div>

          {}
          <Card className="bg-card/80 backdrop-blur-md border-border shadow-2xl shadow-primary/5 overflow-hidden relative group rounded-3xl">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
            
            <CardContent className="p-8 flex flex-col gap-8 relative z-10">
              {}
              <div className="pb-6 border-b border-border/50">
                <img src="/img/hydroflush_logo.png" alt="Hydroflush logo" className="h-10 object-contain" />
              </div>

              {}
              <div className="flex flex-col gap-6">
                <div className="flex items-start gap-4 group/item">
                  <div className="p-3 rounded-xl bg-accent border border-primary/20 text-primary shadow-sm transition-all duration-300 group-hover/item:bg-primary group-hover/item:text-white">
                    <MapPin className="w-5 h-5" />
                  </div>
                  <div className="pt-1">
                    <p className="text-xs font-mono font-semibold text-primary uppercase tracking-widest mb-1">
                      Obszar
                    </p>
                    <p className="font-sans font-bold text-foreground leading-snug">Śląsk, Małopolska</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 group/item">
                  <div className="p-3 rounded-xl bg-accent border border-primary/20 text-primary shadow-sm transition-all duration-300 group-hover/item:bg-primary group-hover/item:text-white">
                    <Phone className="w-5 h-5" />
                  </div>
                  <div className="pt-1">
                    <p className="text-xs font-mono font-semibold text-primary uppercase tracking-widest mb-1">
                      Zadzwoń do nas
                    </p>
                    <p className="font-sans font-bold text-foreground text-xl tracking-tight">+48 796 280 315</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 group/item">
                  <div className="p-3 rounded-xl bg-accent border border-primary/20 text-primary shadow-sm transition-all duration-300 group-hover/item:bg-primary group-hover/item:text-white">
                    <Mail className="w-5 h-5" />
                  </div>
                  <div className="pt-1">
                    <p className="text-xs font-mono font-semibold text-primary uppercase tracking-widest mb-1">
                      Napisz e-mail
                    </p>
                    <p className="font-sans font-bold text-foreground">
                      kontakt@hydroflush.pl
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      {}
      <div className="w-full lg:w-[60%] relative min-h-[400px] lg:min-h-auto bg-slate-50 overflow-hidden">
        {}
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/pszczyna_map_light.png)] opacity-70 transition-transform duration-1000 hover:scale-105"></div>
        
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent lg:bg-gradient-to-r lg:from-background lg:via-background/20 lg:to-transparent"></div>
        <div className="absolute inset-0 bg-primary/5"></div>

        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
          <div className="relative">
            <MapPin className="w-16 h-16 text-primary drop-shadow-[0_0_20px_rgba(0,102,255,0.4)] relative z-10" fill="currentColor" />
            {}
            <div className="absolute inset-0 bg-primary/20 rounded-full blur-2xl animate-pulse"></div>
          </div>
          
          {}
          <div className="w-8 h-2 bg-foreground/10 rounded-[100%] mt-1 blur-[3px]"></div>

          {}
          <div className="mt-6 bg-white/90 backdrop-blur-md border border-border px-6 py-3 rounded-full shadow-2xl shadow-primary/10">
            <p className="text-sm font-bold text-foreground whitespace-nowrap tracking-tight">
              Hydroflush Pszczyna
            </p>
          </div>
        </div>
      </div>
    </section>;
}